'use client';

import { StudioAction } from '@/components/ui/StudioAction';

import { useTranslations } from 'next-intl';
import { readEntitlementFailure, entitlementPurchaseIntent, entitlementRequiredCredits, entitlementMessageKey } from '@/lib/entitlement-failure';
import { presentEntitlementFailure } from '@/lib/subscription-entitlements';
import { SUPPORT_EMAIL } from '@/lib/legal/merchant';

/** Reading history never starts checkout or retries a paid operation. */
export function EntitlementFailureNotice({ failure: input, className = '' }: { failure: unknown; className?: string }) {
  const t = useTranslations('entitlements');
  const failure = readEntitlementFailure(input);
  if (!failure) return null;
  const intent = entitlementPurchaseIntent(failure);
  const required = entitlementRequiredCredits(failure);
  const available = failure.details.available ?? failure.details.availableCredits ?? failure.details.available_credits;
  const messageKey = entitlementMessageKey(failure);
  const buttonClass = 'nodrag nopan mt-2 gap-2';
  return <div data-entitlement-failure={failure.code} role="status" className={`text-xs text-slate-700 ${className}`}>
    <p>{t(messageKey)}</p>
    {required !== undefined && typeof available === 'number' && Number.isFinite(available) && <p className="mt-1">{t('amounts', { required, available })}</p>}
    {typeof failure.details.reset_at === 'string' && <p className="mt-1">{t('resetAt', { at: failure.details.reset_at })}</p>}
    {intent && <StudioAction variant="primary" size="compact" type="button" className={buttonClass} onClick={event => { event.stopPropagation(); presentEntitlementFailure(failure); }}>{t(intent === 'topup' ? 'topup' : 'viewPlans')}</StudioAction>}
    {!intent && (failure.action === 'contact_support' || failure.code === 'WALLET_FROZEN') && <StudioAction variant="primary" size="compact" className={buttonClass} href={`mailto:${SUPPORT_EMAIL}`} onClick={event => event.stopPropagation()}>{t('contactSupport')}</StudioAction>}
  </div>;
}
